import Widget               from "lib/widget";
import AjaxFileForm         from "servos/ajaxFileForm";
import { initBootstrapComponents } from "lib/bootstrapTooltips";

class InvoiceUploadWidget extends Widget {
  bind() {
    this.modalContainer = this.root.find('#checklist-modal-container');
    this.checklistsRoot = this.root.find('#checklists-main-tab');
    bindInvoiceUploadWidget.call(this)
    bindInvoiceComplete.call(this)
  }
}

let bindInvoiceUploadWidget = function() {
  this.checklistsRoot.on('click', '.upload-invoice', (e) => {
    let documentUrl = e.currentTarget.dataset.url
    $.ajax({
      url: documentUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      this.modalContainer.html(response.html);
      this.modalContainer.find('.modal').modal('show');
      this.formElem = this.modalContainer.find('form');
      bindAjaxForm.call(this)
      this.emit('form-loaded')
    })
  })
}

let bindInvoiceComplete = function() {
  this.checklistsRoot.on('click', '.complete-invoice', (e) => {
    let documentUrl = e.currentTarget.dataset.url
    $.ajax({
      url: documentUrl,
      method: 'get',
      dataType: 'json'
    }).done((response) => {
      $((`.checklist-item[data-item-id=${response.item.id}]`)).replaceWith(response.item.html);
      initBootstrapComponents(this.checklistsRoot);
    })
  })
}

let bindAjaxForm = function() {
  this.ajaxForm = new AjaxFileForm(this.formElem)
  this.ajaxForm.on('success', updateItemRow.bind(this))
  this.ajaxForm.on("error",   errorResponse.bind(this))
};

// update item row
let updateItemRow = function(response) {
  let itemRow = this.checklistsRoot.find(`.checklist-item[data-item-id=${response.data.item.id}]`)
  itemRow.replaceWith(response.data.item.html);
  initBootstrapComponents(this.checklistsRoot);
  this.root.find('#general-badge').html(response.data.project.outstanding_general_badge)
  this.root.find('#project-checklist-labels').html(response.data.project.checklist_labels)
  this.modalContainer.find('.modal').modal('hide');
  this.emit('item-updated')
}


let errorResponse = function(response) {
  this.formElem.replaceWith(response.jqXHR.responseJSON.formHtml);
  this.formElem = this.modalContainer.find('form');
  bindAjaxForm.call(this);
  this.emit('form-loaded');
}

export default InvoiceUploadWidget
